import React from "react";
import { Line } from "react-chartjs-2";
import { Chart, LinearScale, CategoryScale, PointElement, LineElement, Tooltip, Legend } from "chart.js";
import { FREQUENCIES } from "./constants";
Chart.register(LinearScale, CategoryScale, PointElement, LineElement, Tooltip, Legend);

function AudiogramChart({ results, minDb = -10, maxDb = 120, stepDb = 5 }) {
  // Dữ liệu từng nhóm
  const leftAir = FREQUENCIES.map(f => {
    const r = results.find(r => r.freq === f && r.ear === "left" && r.conduction === "air");
    return r ? r.db : null;
  });
  const rightAir = FREQUENCIES.map(f => {
    const r = results.find(r => r.freq === f && r.ear === "right" && r.conduction === "air");
    return r ? r.db : null;
  });
  const leftBone = FREQUENCIES.map(f => {
    const r = results.find(r => r.freq === f && r.ear === "left" && r.conduction === "bone");
    return r ? r.db : null;
  });
  const rightBone = FREQUENCIES.map(f => {
    const r = results.find(r => r.freq === f && r.ear === "right" && r.conduction === "bone");
    return r ? r.db : null;
  });

  const chartData = {
    labels: FREQUENCIES.map(f => f + "Hz"),
    datasets: [
      {
        label: 'Tai trái - Đường khí ("O")',
        data: leftAir,
        borderColor: "blue",
        backgroundColor: "blue",
        fill: false,
        tension: 0.3,
        pointStyle: "circle",
        pointRadius: 8,
        showLine: true,
      },
      {
        label: 'Tai phải - Đường khí ("X")',
        data: rightAir,
        borderColor: "red",
        backgroundColor: "red",
        fill: false,
        tension: 0.3,
        pointStyle: "cross",
        pointRadius: 8,
        showLine: true,
      },
      {
        label: 'Tai trái - Đường xương (">")',
        data: leftBone,
        borderColor: "blue",
        backgroundColor: "blue",
        fill: false,
        tension: 0.3,
        pointStyle: "triangle",
        pointRadius: 10,
        showLine: true,
        segment: { borderDash: [6, 4] }
      },
      {
        label: 'Tai phải - Đường xương ("<")',
        data: rightBone,
        borderColor: "red",
        backgroundColor: "red",
        fill: false,
        tension: 0.3,
        pointStyle: "triangle",
        pointRadius: 10,
        showLine: true,
        segment: { borderDash: [6, 4] }
      }
    ]
  };

  const options = {
    plugins: {
      legend: { position: "bottom" },
      tooltip: { enabled: true }
    },
    scales: {
      y: {
        title: { display: true, text: "Ngưỡng nghe (dB)" },
        min: minDb,
        max: maxDb,
        reverse: true, // dB nhỏ ở trên, lớn ở dưới
        ticks: { stepSize: stepDb, callback: v => v }
      },
      x: { title: { display: true, text: "Tần số (Hz)" } }
    },
    elements: {
      point: {
        pointStyle: (ctx) => {
          const dsIdx = ctx.datasetIndex;
          if (dsIdx === 0) return "circle";
          if (dsIdx === 1) return "cross";
          return "triangle";
        },
        backgroundColor: (ctx) => {
          const dsIdx = ctx.datasetIndex;
          return dsIdx === 0 || dsIdx === 2 ? "blue" : "red";
        },
        borderColor: (ctx) => {
          const dsIdx = ctx.datasetIndex;
          return dsIdx === 0 || dsIdx === 2 ? "blue" : "red";
        },
        radius: 8
      }
    }
  };

  return <Line data={chartData} options={options} />;
}

export default AudiogramChart;